module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-3-228a8d6d0abd5c6ec521ebf3021893fe.jpg";